import { createLayoutOption } from 'switch-fe-shared/components/Layout/LayoutPreviewGenerator';
import type { LayoutOption } from 'switch-fe-shared/components/Layout/types';

import {
  getBHATemplate,
  getExecutiveTemplate,
  getGroupsOverviewTemplate,
  getOperationalTemplate,
  getPpaSiteTemplate,
  type LayoutTemplate,
} from './layouts';

/**
 * Layout options with automatically generated previews.
 * Previews are generated from the actual layout definitions,
 * ensuring they always match the real layouts.
 */
export const layoutOptions: LayoutOption<LayoutTemplate>[] = [
  createLayoutOption({
    template: 'executive',
    name: 'Executive View',
    description:
      'Essential metrics at-a-glance, medium-sized chart, and auxiliary location information. Best for quick overviews.',
    layouts: getExecutiveTemplate(false).layouts,
    previewMaxRows: 52,
  }),
  createLayoutOption({
    template: 'operational',
    name: 'Operational View',
    description:
      'Comprehensive view with larger widgets for detailed monitoring, and expanded map. Ideal for in-depth analysis.',
    layouts: getOperationalTemplate(false).layouts,
    previewMaxRows: 15,
  }),
  // createLayoutOption({
  //   template: 'analytics',
  //   name: 'Analytics Focus',
  //   description:
  //     'Chart-centric layout emphasizing data visualization. Perfect for data analysis.',
  //   layouts: getAnalyticsTemplate().layouts,
  //   previewMaxRows: 52,
  // }),
  createLayoutOption({
    template: 'groups-overview',
    name: 'Groups Overview',
    description:
      'Full-screen application groups overview table. View all groups with their metrics, meters, gateways, and alerts at a glance.',
    layouts: getGroupsOverviewTemplate().layouts,
    previewMaxRows: 52,
  }),
  createLayoutOption({
    template: 'ppa-site',
    name: 'PPA / RRA Site',
    description:
      'Site meters and electricity usage, with solar yield, solar share, demand reduction and savings against forecast for the selected site.',
    layouts: getPpaSiteTemplate(false).layouts,
    previewMaxRows: 40,
  }),
  createLayoutOption({
    template: 'bha',
    name: 'Borehole Africa View',
    description: 'Custom dashboard for Borehole Africa.',
    layouts: getBHATemplate(false).layouts,
    previewMaxRows: 52,
  }),
];
